import axios from "axios";
import { baseurl, token } from "../../BaseUrl";

export const getRestaurantByIdApi = async (id) => {
  try {
    const res = await axios.get(`${baseurl}/getRestaurantById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(res.data);
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.error };
  }
};

export const getRestaurantReviewApi = async (id) => {
  try {
    const res = await axios.get(`${baseurl}/restaurant-review/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.error };
  }
};

export const getRestaurantBookingApi = async (id) => {
  try {
    const res = await axios.get(`${baseurl}/restaurantBooking/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.error };
  }
};
